import { useState } from 'react'
import CatalogService from './CatalogService'
import CatalogServiceModal from 'pages/Modals/CatalogServiceModal'
import { Container, InfoText } from './styles'

export default function CatalogServiceList ({ 
  services = [],
  catalogID,
  onEdit: handleEdit = () => {},
  onDelete: handleDelete = () => {}
}) {
  const [catalogServiceData, setCatalogServiceData] = useState (null)
  const [showCatalogServiceModal, setShowCatalogServiceModal] = useState (false)

  const editCatalogService = catalogService => {
    setCatalogServiceData (catalogService)
    toggleCatalogServiceModal ()
  }

  const toggleCatalogServiceModal = () => setShowCatalogServiceModal (!showCatalogServiceModal)
  
  if (services.length === 0) return (
    <Container>
      <InfoText style={{textAlign: 'center', marginTop: 15}}>
        Nenhum serviço cadastrado nesta categoria
      </InfoText>
    </Container>
  )

  return (
    <Container>
      {services.map (service => (
        <CatalogService 
          key={service.id} 
          data={service}
          catalogID={catalogID}
          onEdit={editCatalogService}
          onDelete={handleDelete}
        />
      ))}
      {!!catalogServiceData && (
        <CatalogServiceModal
          visible={showCatalogServiceModal}
          service={catalogServiceData}
          catalogID={catalogID}
          onConfirm={handleEdit}
          onClose={toggleCatalogServiceModal}
        />
      )}
    </Container>
  )
}
